// CRIO_SOLUTION_START_MODULE_LOGIN
// CRIO_SOLUTION_END_MODULE_LOGIN
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Lato"
  },
  palette: {
    primary: {
      light: "#45c09f",
      main: "#00a278",
      dark: "#00845c",
      contrastText: "#fff",
    },
  },
});

export default theme;
